<!--
 * @Author: Louis
 * @Date: 2020-02-18 17:15:48
 * @LastEditors: Louis
 * @LastEditTime: 2020-02-18 18:29:39
 * @Description:
 * @FieldType: 7 日期、5 单选、29 地址、9 附件、4 金额、3 数值、11 明细
 -->
<template>
  <div
    class="business-model"
    v-loading.fullscreen.lock="showLoading"
    :class="{ 'is-pc': type === 'PC', 'is-mobile': type === 'MOBILE' }"
  >
    <div class="title" v-if="success">
      {{ dataInfo.mdInfo && dataInfo.mdInfo.templateName }}
    </div>
    <div v-if="success" class="business-model-container">
      <mainComponent
        :disabled="isDisable"
        :browserType="type"
        :commondata="commondata"
        v-model="list"
        @change="changeValue"
      ></mainComponent>
    </div>
    <div v-if="success && !isDisable && !showLoading" class="submit-button">
      <div class="content" @click="submitDataInfo">
        {{ pending ? '提交中' : '提交' }}
      </div>
    </div>
    <en-tips v-model="showTips" :tips="message"></en-tips>
    <div v-if="!success" @click="getTemplateInfo" class="error-tips">
      操作失败，点击重试。
    </div>
  </div>
</template>
<script>
import mainComponent from './../../components/main'
import enTips from './../../components/en-tips'
import { calculate } from './calculate'
import Vue from 'vue'
import {
  updateAllAreaPermissions,
  updateAreaPermissions,
  updateConfig,
} from './updatePermissions'
import { dateFormat } from './tools'
// import dataList from "./data"

export default {
  name: 'businessModel',
  components: { mainComponent, enTips },
  data() {
    return {
      count: 0,
      list: [],
      dataInfo: {},
      showTips: false,
      message: '',
      success: true,
      pending: false,
      showLoading: false,
      isDisable: false,
      formId: null,
      isNewAdd: true,
      commondata: {
        getRelationCondition: this.getRelationCondition,
      },
    }
  },
  computed: {
    type() {
      return /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)
        ? 'MOBILE'
        : 'PC'
    },
    computeRuleList() {
      if (
        this.dataInfo.mdInfo &&
        this.dataInfo.mdInfo.templateExt &&
        Array.isArray(this.dataInfo.mdInfo.templateExt.computeRuleList)
      ) {
        return this.dataInfo.mdInfo.templateExt.computeRuleList.filter(
          (item) => {
            return Number(item.ruleVersion) >= 2
          }
        )
      }
      return []
    },
    computeRuleInfo() {
      if (this.computeRuleList.length === 0) {
        return {}
      }
      let info = {}

      //合并受同一个控件计算公式中，控件的field作为key，value为数组
      function handleExpressRuleField(computeRuleItem, expressRuleItem) {
        if (expressRuleItem.key !== 'fields') {
          return
        }
        if (!info[expressRuleItem.value]) {
          info[expressRuleItem.value] = []
        }
        let value = info[expressRuleItem.value]
        if (value.indexOf(computeRuleItem) === -1) {
          value.push(computeRuleItem)
        }
      }

      //处理
      for (const computeRuleItem of this.computeRuleList) {
        //新版计算公式，合并受同一个控件计算公式中，控件的field作为key，value为数组
        for (const expressRuleItem of computeRuleItem.expressRule) {
          if (expressRuleItem.key === 'fun') {
            for (const expressRuleFunItem of expressRuleItem.value) {
              handleExpressRuleField(computeRuleItem, expressRuleFunItem)
            }
          } else {
            handleExpressRuleField(computeRuleItem, expressRuleItem)
          }
        }
      }
      return info
    },
    uploadInfo() {
      return JSON.parse(localStorage.getItem('uploadInfo'))
    },
  },
  mounted() {
    let query = this.$route.query
    let params = {
      tenantId: query.t ? query.t : query.tenantId ? query.tenantId : null,
      userId: query.u ? query.u : query.userId ? query.userId : null,
      templateId: query.m
        ? query.m
        : query.templateId
        ? query.templateId
        : null,
      shareCheckId: query.s
        ? query.s
        : query.shareCheckId
        ? query.shareCheckId
        : null,
      timestamp: query.p ? query.p : query.timestamp ? query.timestamp : null,
    }
    if (query.sid) {
      params.sid = query.sid
      params.ids = query.sid
    }
    localStorage.setItem('submitToken', new Date().getTime())
    localStorage.setItem('params', JSON.stringify(params))
    this.isNewAdd = !(query.sid && query.sid.length > 0) // 4.9.21
    this.formId = params.sid ? query.sid : null
    this.getTemplateInfo()
  },
  methods: {
    /**
     * @description 获取模板信息
     * @return {Promise<void>}
     */
    async getTemplateInfo() {
      this.showLoading = true
      let result = await this.$api.post('/mdSearchShareTemp')
      if (result.isSuccess) {
        this.showLoading = false
        this.dataInfo = result.data
        try {
          document.title = result.data.mdInfo.shareContent.content
        } catch (e) {
          document.title = ''
        }

        this.success = true
        // 移除查看流程控件
        this.dataInfo.fieldAttr = this.dataInfo.fieldAttr.filter((col) => {
          if (String(col.fieldType) === '44' && this.isNewAdd) {
            return false
          }
          return String(col.fieldType) !== '8'
        })

        let list = await this.resetSubList(this.dataInfo.fieldAttr)
        list = await this.setListValue(list)
        list = await this.setComponentEdit(
          list,
          this.dataInfo.powerList,
          this.dataInfo.sharePower
        )
        if (this.isNewAdd) {
          list = await this.setDefaultValue(list)
        }
        list = await this.setComponentsShow(
          list,
          this.dataInfo.powerList,
          this.dataInfo.sharePower
        )
        let flowInfos = list.filter((col) => {
          return String(col.fieldType) === '44'
        })
        list = list.filter((col) => {
          return String(col.fieldType) !== '44'
        })
        if (this.formId && flowInfos.length > 0 && flowInfos[0].isShow) {
          let flowResult = await this.$api.post('/wfQueryFlowDetailShare')
          if (flowResult.isSuccess) {
            list.push(...flowInfos)
            flowResult.data.forEach((item) => {
              item.isOpen = false
            })
            Vue.set(flowInfos[0], 'data', flowResult.data)
            flowInfos[0].queryFlowBranchDetail = async (data, callback) => {
              if (data.children) {
                callback()
                return
              }
              let result = await this.$api.post(
                '/wfQueryFlowBranchDetailShare',
                { params: { nodeId: data.nodeId, processInstanceId: data.processInstanceId, pId: this.dataInfo.mdInfo.pId } }
              )
              if (result.isSuccess) {
                data.children = result.data
                callback()
              } else {
                callback()
                if (this.type === 'PC') {
                  this.$notify({
                    type: 'error',
                    title: '操作失败',
                    message: result.msg,
                  })
                } else {
                  this.showTips = true
                  this.message = result.msg
                }
              }
            }
          }
        }
        this.list = list
        updateConfig(this.list)
        if (!this.isNewAdd) {
          this.isDisable = parseInt(this.dataInfo.operationType, 10) !== 2
          let result = await this.$api.post('/mdEditObjectCheckShare')
          let isInFlow = this.dataInfo.mdInfo.billStatus === "001" ||
          this.dataInfo.mdInfo.billStatus === "002" ||
          this.dataInfo.mdInfo.billStatus === "007"
          if (!result.isSuccess || isInFlow) {
            this.isDisable = true
          }
          this.resetValueInfo(
            this.dataInfo.mdData ? this.dataInfo.mdData : {},
            this.list
          )
        }
        updateAllAreaPermissions(this.list)
        localStorage.setItem(
          'uploadInfo',
          JSON.stringify(this.dataInfo.mdInfo.fileUploadMap)
        )
        localStorage.setItem('templateName', this.dataInfo.mdInfo.templateName)
        if (
          this.dataInfo.mdInfo.shareContent &&
          this.dataInfo.mdInfo.shareContent.icon
        ) {
          const uploadInfo = this.dataInfo.mdInfo.fileUploadMap
          document.head.querySelector('#favicon').href =
            uploadInfo.showImageServer +
            '?token=' +
            uploadInfo.showImageToken +
            '&fileCode=' +
            this.dataInfo.mdInfo.shareContent.icon +
            '&appKey=' +
            uploadInfo.appKey +
            '&ts=' +
            uploadInfo.imgTs
        }
      } else {
        this.showLoading = false
        if (this.type === 'PC') {
          this.$notify({
            type: 'error',
            title: '温馨提示',
            message: result.msg,
          })
        } else {
          this.showTips = true
          this.message = result.msg
        }
        this.success = false
      }
    },
    /**
     * @description 给每一项设置value字段，承载数据
     * @param list
     * @return {*}
     */
    setListValue(list) {
      list.map((item) => {
        // 如果是明细区
        if (item.sub) {
          item.sub.map((cItem) => {
            cItem.map((sItem) => {
              if (parseInt(sItem.fieldType, 10) === 29) {
                sItem.value = null
              } else if (parseInt(sItem.fieldType, 10) === 5) {
                sItem.singleList = []
              } else {
                sItem.value = null
              }
            })
          })
        } else {
          if (parseInt(item.fieldType, 10) === 29) {
            item.value = null
            // 单选
          } else if (parseInt(item.fieldType, 10) === 5) {
            item.singleList = []
          } else {
            item.value = null
          }
        }
      })
      return list
    },
    // 获取关联条件，获取singleRelationCondition配置有关的值
    getRelationCondition(info) {
      var params = {}
      const hasCondition =
        Array.isArray(info.singleRelationCondition) &&
        info.singleRelationCondition.length > 0
      if (hasCondition) {
        const commonSetParams = {}
        const infos = this.getAllAreaInfos(info)
        info.singleRelationCondition.map((condition) => {
          const value = this.getRelationConditionVlaue(condition, infos)
          commonSetParams[condition.targetField] = value
        })
        params.commonSet = JSON.stringify({ relationSet: commonSetParams })
      }
      if (
        (parseInt(info.assignType, 10) === 2 &&
          Array.isArray(info.singleRangeFilter) &&
          info.singleRangeFilter.length > 0) ||
        hasCondition
      ) {
        params.version = this.dataInfo.mdInfo.version
        params.templateType =
          parseInt(this.dataInfo.mdInfo.type, 10) === 1 ? 2 : 1
        return params
      }
      return null
    },
    /*获取info区域的字段数据和上级区域字段数据 */
    getAllAreaInfos(info) {
      if (this.list.indexOf(info) !== -1) {
        return [...this.list]
      }
      const infos = []
      this.list.map((item) => {
        if (info.sub) {
          const subs = item.sub.filter(
            (subItems) => subItems.indexOf(item) !== -1
          )
          if (subs.length > 0) {
            infos.push(...subs[0])
          }
        }
      })
      return infos
    },
    // 获取单个字段的值，如果没有传null
    getRelationConditionVlaue(condition, infos) {
      if (
        condition.targetField === 'createId' &&
        this.dataInfo.mdData['createId']
      ) {
        return [
          {
            id: this.dataInfo.mdData['createId'],
            name: this.dataInfo.mdData['createName'],
          },
        ]
      }
      if (
        condition.targetField === 'createId' &&
        this.dataInfo.mdData['createDepId']
      ) {
        return [
          {
            id: this.dataInfo.mdData['createDepId'],
            name: this.dataInfo.mdData['createDepName'],
          },
        ]
      }
      if (
        condition.targetField === 'createTime' &&
        this.dataInfo.mdData['createOrgId']
      ) {
        return [
          {
            id: this.dataInfo.mdData['createOrgId'],
            name: this.dataInfo.mdData['createOrgName'],
          },
        ]
      }
      if (condition.targetField === 'createTime') {
        if (this.dataInfo.mdData['createTime']) {
          return this.dataInfo.mdData['createTime']
        }
        return dateFormat('yyyy-MM-dd HH:mm:ss', Date())
      }
      const values = infos.filter(
        (item) => condition.targetField === item.field
      )
      if (values.length > 0) {
        return values[0].value
      }
      return null
    },
    /**
     * @description 设置默认值
     */
    setDefaultValue(list) {
      list.map((item) => {
        if (item.sub) {
          item.sub.map((cItem) => {
            cItem.map((sItem) => {
              if (sItem.defaults && sItem.defaults !== '') {
                let type = parseInt(sItem.fieldType, 10)
                if (type === 3 || type === 4) {
                  sItem.value = parseFloat(sItem.defaults).toFixed(2)
                } else if (
                  parseInt(sItem.fieldType, 10) === 7 &&
                  sItem.defaults.indexOf('#') !== -1
                ) {
                  sItem.value = sItem.defaults.split('#')[1]
                } else if (
                  parseInt(sItem.fieldType, 10) === 5 ||
                  parseInt(sItem.fieldType, 10) === 15
                ) {
                  sItem.value = JSON.parse(sItem.defaults)
                } else {
                  sItem.value = sItem.defaults
                }
              }
            })
          })
        } else {
          if (item.defaults && item.defaults !== '') {
            let type = parseInt(item.fieldType, 10)
            if (type === 3 || type === 4) {
              item.value = parseFloat(item.defaults).toFixed(2)
            } else if (
              parseInt(item.fieldType, 10) === 7 &&
              item.defaults.indexOf('#') !== -1
            ) {
              item.value = item.defaults.split('#')[1]
            } else if (
              parseInt(item.fieldType, 10) === 5 ||
              parseInt(item.fieldType, 10) === 15
            ) {
              item.value = JSON.parse(item.defaults)
            } else {
              item.value = item.defaults
            }
          }
        }
      })
      return list
    },
    /**
     * @description 重设明细区的数据
     */
    async resetSubList(list) {
      list.map((item) => {
        if (item.sub) {
          let arr = []
          item.sub.map((cItem) => {
            arr.push(cItem)
          })
          item.templateSub = arr
          item.sub = []
          item.sub.push(this.deepCopySub(item))
        }
      })
      return list
    },
    /** 深拷贝item的templateSub数据 */
    deepCopySub(item) {
      var data = JSON.stringify(item.templateSub)
      data = JSON.parse(data)
      return data
    },
    /**
     * @description 增加控件的显示隐藏设置
     * @param list
     * @param powerList
     * @param sharePower 共享显示和必填权限
     */
    setComponentsShow(list, powerList, sharePower) {
      var isNewAdd = this.isNewAdd
      console.log(isNewAdd);
      function withOutShow(item) {
        item.isShow = true;
        powerList.map((cItem) => {
          if (cItem.field === item.field && parseInt(cItem.isShow, 10) !== 0) {
            item.isShow = false;
          }
        })
        if (Array.isArray(sharePower) && sharePower.length > 0 && item.isShow) {
          let isUpdate = false
          sharePower.map((cItem) => {
            if (cItem.field === item.field) {
              isUpdate = true
              if (parseInt(cItem.isShow, 10) !== 0) {
                item.isShow = false;
              }
              // 4.9.21新增数据分享，新增用以前的
              if (
                isNewAdd &&
                cItem.requrein != undefined &&
                parseInt(item.requrein, 10) !== 0
              ) {
                item.requrein = cItem.requrein;
              }
            }
          })
          if (!isUpdate) {
            item.isShow = false;
          }
          if (parseInt(item.pageHide, 10) === 0) {
            item.isShow = false;
          }
        }
      }
      list.map((item) => {
        if (!item.sub) {
          withOutShow(item)
        } else {
          withOutShow(item)
          item.sub.map((cItem) => {
            cItem.map((sItem) => {
              withOutShow(sItem)
            })
          })
          item.templateSub.map((item) => {
            withOutShow(item)
          })
        }
      })
      return list
    },
    /**
     * @description 设置组件是否可编辑
     */
    setComponentEdit(list, powerList, sharePower) {
      function withoutEdit(item) {
        powerList.map((cItem) => {
          if (cItem.field !== item.field) {
            return
          }
          if (parseInt(cItem.isEdit, 10) === 1) {
            item.disabled = true
          }
          if (cItem.requrein && cItem.requrein.length > 0) {
            Vue.set(item, 'requrein', cItem.requrein)
          }
        })
        if (!item.disabled && sharePower.length > 0) {
          sharePower.map((cItem) => {
            if (cItem.field === item.field) {
              if (parseInt(cItem.isEdit, 10) === 1) {
                item.disabled = true
              }
            }
          })
        }
      }

      list.map((item) => {
        item.disabled = false
        if (!item.sub) {
          withoutEdit(item)
        } else {
          item.sub.map((cItem) => {
            cItem.map((sItem) => {
              withoutEdit(sItem)
            })
          })
          item.templateSub.map((item) => {
            withoutEdit(item)
          })
        }
      })
      return list
    },
    /**
     * @description 提交表单数据
     */
    async submitDataInfo() {
      if (this.pending) {
        return
      }
      let params = {}
      // 校验提示
      let checkFlag = true
      let checkMsg = ''
      let result = {}
      const typeArr = [1, 5, 7, 29, 9, 4, 3, 11]
      this.list.map(async (item) => {
        if (checkMsg.length > 0) {
          return
        }
        // 如果选项显示控制不显示，不校验，不提交
        if (item.optionShow && !item.isShow) {
          return
        }
        const type = parseInt(item.fieldType, 10)
        // 流程不管
        if (type === 44) {
          return
        }
        // 如果是明細區
        if (item.sub) {
          let subData = []
          let allFlag = false
          item.sub.map((cItem) => {
            // 如果选项显示控制不显示，不校验，不提交
            if (cItem.optionShow && !cItem.isShow) {
              return
            }
            let cItemObj = {}
            let flag = false
            cItem.map(async (sItem) => {
              if (checkMsg.length > 0) {
                return
              }
              const sType = parseInt(sItem.fieldType, 10)
              // 先检测是否有值
              if (
                sItem.value &&
                (((sType === 5 || sType === 15) && sItem.value !== '[]') ||
                  (sType !== 5 && sType !== 15))
              ) {
                if (!flag) {
                  flag = !(sType === 5 && sItem.value === '[]')
                }
                // 检测必填项
                if (parseInt(sItem.requrein, 10) !== 1) {
                  // 如果编码规则是2或者3，需要检测规则是否为空数组，
                  // 空数组要检测必填
                  if (
                    parseInt(sItem.ruleGenerateType, 10) === 2 ||
                    parseInt(sItem.ruleGenerateType, 10) === 3
                  ) {
                    if (sItem.codeRule.length === 0 && !sItem.value) {
                      checkFlag = false
                      checkMsg =
                        '请填写' + item.name + '下的' + sItem.name + '字段'
                    }
                  } else if (sType === 5 && sItem.value === '[]') {
                    checkFlag = false
                    checkMsg =
                      '请选择' + item.name + '下的' + sItem.name + '字段'
                  } else if (!sItem.value && typeArr.indexOf(sType) !== -1) {
                    checkFlag = false
                    checkMsg =
                      '请填写' + item.name + '下的' + sItem.name + '字段'
                  }
                }
                // 如果是金额或者数值，检测数据类型
                if ((sType === 4 || sType === 3) && item.value) {
                  if (!/^[+-]?(0|([1-9]\d*))(\.\d+)?$/g.test(sItem.value)) {
                    checkFlag = false
                    checkMsg =
                      +item.name +
                      '下的' +
                      sItem.name +
                      '数据格式有误，请重新填写'
                  } else {
                    if (sItem.reserverDecimal) {
                      params[sItem.field] = parseFloat(sItem.value).toFixed(
                        sItem.reserverDecimal
                      )
                    } else {
                      params[sItem.field] = parseFloat(sItem.value)
                    }
                  }
                } else {
                  if (
                    (sType === 5 || sType === 15) &&
                    sItem.value &&
                    (sItem.value.length === 0 || sItem.value === '[]')
                  ) {
                    //过滤数据
                  } else {
                    cItemObj[sItem.field] = sItem.value
                  }
                }
              } else if (parseInt(sItem.requrein, 10) !== 1) {
                checkFlag = false
                checkMsg = '请填写' + item.name + '下的' + sItem.name + '字段'
              }
            })
            if (!item.isShow) {
              checkFlag = true
              checkMsg = ''
            }
            if (flag) {
              allFlag = true
              subData.push(cItemObj)
            }
          })
          if (allFlag) {
            params[item.field] = subData
          }
        } else {
          // 如果设置了必填选项
          if (
            parseInt(item.requrein, 10) !== 1 &&
            (!item.value ||
              item.value === '' ||
              (item.value &&
                (type === 5 || type === 15) &&
                item.value === '[]'))
          ) {
            /* eslint-disable */
            // 非地址情况下
            if (type !== 29) {
              // 如果编码规则是2或者3，需要检测规则是否为空数组，
              // 空数组要检测必填
              if (
                parseInt(item.ruleGenerateType, 10) === 2 ||
                parseInt(item.ruleGenerateType, 10) === 3
              ) {
                if (item.codeRule.length === 0 && !item.value) {
                  checkFlag = false
                  checkMsg = '请填写' + item.name + '字段'
                } else {
                  params[item.field] = item.value
                }
              } else if ((type === 5 || type === 15) && item.value === '[]') {
                checkFlag = false
                checkMsg = '请选择' + item.name + '字段'
              } else if (!item.value && typeArr.indexOf(type) !== -1) {
                checkFlag = false
                checkMsg = '请填写' + item.name + '字段'
              } else if (item.value) {
                params[item.field] = item.value
              } else {
                checkFlag = false
                checkMsg = '请填写' + item.name + '字段'
              }
              if (!item.isShow) {
                checkFlag = true
                checkMsg = ''
              }
            }
            // 如果是住址信息
            else {
              result = await this.checkNotEmptyAreaData(item)
              checkFlag = result.flag
              checkMsg = result.msg
            }
          } else if (item.value && item.value !== '') {
            // 如果是数值或者金额，需要转成Float给后台
            if (
              parseInt(item.fieldType, 10) === 4 ||
              parseInt(item.fieldType, 10) === 3
            ) {
              if (
                !item.suffix ||
                (item.suffix !== '%' && parseInt(item.suffix, 10) !== 2)
              ) {
                result = await this.checkNumData(item, params)
                checkFlag = result.flag
                checkMsg = result.msg
              }
              // 判断数据的后缀是否为万元
              if (item.suffix && item.suffix === 2) {
                params[item.field] = item.value * 10000
              }
              // 判断数据的后缀是否为百分号
              if (item.suffix && item.suffix === '%') {
                params[item.field] = (item.value.toString() / 100).toFixed(2)
              }
            } else {
              if (
                (parseInt(item.fieldType, 10) === 5 ||
                  parseInt(item.fieldType, 10) === 15) &&
                item.value &&
                (item.value.length === 0 || item.value === '[]')
              ) {
                //过滤数据
              } else {
                params[item.field] = item.value
              }
            }
          }
        }
      })
      if (!checkFlag) {
        if (this.type === 'PC') {
          this.$notify({
            type: 'error',
            title: '操作失败',
            message: checkMsg,
          })
        } else {
          this.message = checkMsg
          this.showTips = true
        }
      } else {
        this.showLoading = true
        this.pending = true
        let params1 = {
          mdData: JSON.stringify(params),
          version: this.dataInfo.mdInfo.version,
        }
        if (this.formId) params1.id = this.formId

        let result = await this.$api.post('/mdSubmitShareData', params1)
        if (result.isSuccess) {
          if (parseInt(result.data.jumpType, 10) === 3) {
            this.$router.push({
              name: 'tipsCenter',
              params: {
                tips: this.dataInfo.mdInfo.templateName + '已提交成功',
              },
            })
          } else {
            this.isDisable = parseInt(result.data.jumpType, 10) === 2
            this.formId = result.data.id
            this.reGetDataList()
            if (this.type === 'PC') {
              this.$notify({
                type: 'success',
                title: '操作成功',
                message: this.dataInfo.mdInfo.templateName + '已提交成功',
              })
            } else {
              this.showTips = true
              this.message = this.dataInfo.mdInfo.templateName + '已提交成功'
            }
          }
        } else {
          if (this.type === 'PC') {
            this.$notify({
              type: 'error',
              title: '操作失败',
              message: result.msg,
            })
          } else {
            this.showTips = true
            this.message = result.msg
          }
        }
        setTimeout(() => {
          this.showLoading = false
          this.pending = false
        }, 2000)
      }
    },
    /**
     * @description 檢測數值/金額數據
     */
    async checkNumData(itemData, params) {
      let result = {
        flag: true,
        msg: '',
      }
      if (!/^[+-]?(0|([1-9]\d*))(\.\d+)?$/g.test(itemData.value)) {
        result.flag = false
        result.msg = itemData.name + '数据格式有误，请重新填写'
      } else {
        if (itemData.reserverDecimal) {
          params[itemData.field] = parseFloat(itemData.value).toFixed(
            itemData.reserverDecimal
          )
        } else {
          params[itemData.field] = parseFloat(itemData.value)
        }
      }
      return result
    },
    /**
     * @description 检测是否为非空的地址
     */
    async checkNotEmptyAreaData(itemData) {
      let checkMsg = ''
      let checkFlag = true
      if (!itemData.value) {
        checkMsg = false
        checkMsg = '请选择完整的地址信息'
      } else {
        // 省份
        if (parseInt(itemData.addrRange, 10) === 4) {
          if (!itemData.value.provinceId || !itemData.value.provinceName) {
            checkFlag = false
            checkMsg = '请选择省份'
          }
        }
        // 省+市
        if (parseInt(itemData.addrRange, 10) === 3) {
          if (!itemData.value.provinceId || !itemData.value.provinceName) {
            checkFlag = false
            checkMsg = '请选择省份'
          }
          if (!itemData.value.cityId || !itemData.value.cityName) {
            checkFlag = false
            checkMsg = '请选择市'
          }
        }
        // 省市区
        if (parseInt(itemData.addrRange, 10) === 2) {
          if (!itemData.value.provinceId || !itemData.value.provinceName) {
            checkFlag = false
            checkMsg = '请选择省份'
          }
          if (!itemData.value.cityId || !itemData.value.cityName) {
            checkFlag = false
            checkMsg = '请选择市'
          }
          if (!itemData.value.districtId || !itemData.value.districtName) {
            checkFlag = false
            checkMsg = '请选择区'
          }
        }
        // 省市区+详细地址
        if (parseInt(itemData.addrRange, 10) === 1) {
          if (!itemData.value.provinceId || !itemData.value.provinceName) {
            checkFlag = false
            checkMsg = '请选择省份'
          }
          if (!itemData.value.cityId || !itemData.value.cityName) {
            checkFlag = false
            checkMsg = '请选择市'
          }
          if (!itemData.value.districtId || !itemData.value.districtName) {
            checkFlag = false
            checkMsg = '请选择区'
          }
          if (!itemData.value.address || itemData.value.address.trim() === '') {
            checkFlag = false
            checkMsg = '请填写详细地址信息'
          }
        }
      }
      return {
        flag: checkFlag,
        msg: checkMsg,
      }
    },
    /**
     * @description 重新获取表单数据
     */
    async reGetDataList() {
      let queryList = JSON.parse(localStorage.getItem('params'))
      queryList.id = this.formId
      localStorage.setItem('params', JSON.stringify(queryList))
      const result = await this.$api.post('/mdSearchShareTemp')
      const mdData = result.data.mdData ? result.data.mdData : {}
      this.resetValueInfo(mdData, this.list)
    },
    /**
     * @description 更改某字段的值时触发
     * @param res
     */
    changeValue(res) {
      calculate(res, this.computeRuleInfo, this.list)
      updateAreaPermissions(res, this.list)
      this.list = [...this.list];
    },
    /**
     * @description 重设表单数据信息
     * @param mdData
     */
    resetValueInfo(mdData, list) {
      list.map((item) => {
        if (!item.sub && mdData[item.field]) {
          let result = mdData[item.field]
          // 判断数据的后缀是否为万元
          if (item.suffix && item.suffix === 2) {
            result = result / 10000
          }
          // 判断数据的后缀是否为百分号
          if (item.suffix && item.suffix === '%') {
            result = result * 100
          }
          if (this.isNewAdd) {
            item.mdValue = result
            item.value = result
            if (item._setValue) item._setValue(result)
          } else {
            item.mdValue = result
            item.value = result
            if (item._setValue) item._setValue(result)
          }
        } else if (item.sub) {
          var detailDatas = mdData[item.field]
          if (!Array.isArray(detailDatas)) {
            return
          }
          if (detailDatas.length > item.sub.length) {
            item.sub = []
            detailDatas.map((value) => {
              item.sub.push(this.deepCopySub(item))
            })
          }
          item.sub.map((cItem, cIndex) => {
            cItem.map((sItem) => {
              var val = detailDatas[cIndex][sItem.field]
              if (val) {
                if (this.isNewAdd) {
                  sItem.mdValue = val
                  sItem.value = val
                  if (sItem._setValue) sItem._setValue(val)
                } else {
                  sItem.mdValue = val
                  sItem.value = val
                  if (sItem._setValue) sItem._setValue(val)
                }
              }
            })
          })
        }
      })
    },
  },
}
</script>
<style lang="scss">
.business-model {
  width: 100%;
  height: 100%;
  background-color: #ecf1f7;

  .error-tips {
    width: 100%;
    text-align: center;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #4674de;
  }

  &.is-mobile {
    .title {
      text-align: center;
      line-height: 50px;
      background-color: #31415a;
      color: #ffffff;
      width: 100%;
    }

    .business-model-container {
      width: 100%;
      // overflow: auto;
    }

    .submit-button {
      padding: 15px 0;
      width: calc(100% - 20px);
      margin: 40px auto 40px;
      text-align: center;
      background-color: #677ea3;
      -webkit-border-radius: 45px;
      -moz-border-radius: 45px;
      border-radius: 45px;
      color: #ffffff;
      font-size: 20px;
      letter-spacing: 5px;
      transition: 0.3s ease-in-out all;

      &:active {
        opacity: 0.7;
      }
    }
  }

  &.is-pc {
    padding: 10px 0 0 0;

    .title {
      width: 1000px;
      margin: 0 auto;
      line-height: 50px;
      background-color: #ffffff;
      text-align: center;
      color: #333333;
      border-bottom: 1px solid #f3f3f3;
      -webkit-border-radius: 4px 4px 0 0;
      -moz-border-radius: 4px 4px 0 0;
      border-radius: 4px 4px 0 0;
      font-weight: bold;
    }

    .business-model-container {
      // height: calc(100% - 105px);
      width: 1000px;
      margin: 0 auto;
      overflow: auto;
      padding: 0 0 20px;
      // background-color: #ffffff;

      &::-webkit-scrollbar {
        width: 8px;
        height: 10px;
      }

      &::-webkit-scrollbar-track {
        background: rgb(239, 239, 239);
        border-radius: 2px;
      }

      &::-webkit-scrollbar-thumb {
        background: #bfbfbf;
        border-radius: 10px;
      }

      &::-webkit-scrollbar-thumb:hover {
        background: #333;
      }

      &::-webkit-scrollbar-corner {
        background: #179a16;
      }
    }

    .submit-button {
      width: 1000px;
      margin: 10px auto;
      display: flex;
      justify-content: flex-end;

      .content {
        background-color: #4895df;
        color: #ffffff;
        font-size: 12px;
        line-height: 32px;
        padding: 0 24px;
        -webkit-border-radius: 4px 4px 4px 4px;
        -moz-border-radius: 4px 4px 4px 4px;
        border-radius: 4px 4px 4px 4px;
        cursor: pointer;
        transition: 0.5s ease-in-out all;

        &:hover {
          opacity: 0.7;
        }
      }
    }
  }
}
</style>
